import React from 'react';

export const Checkmark = ({ width = 10, height = 10 }) => {
  return (
    <svg
      fill="#6F0AC6"
      width={width}
      height={height}
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1743.858 267.012L710.747 1300.124 176.005 765.382 0 941.387l710.747 710.871 1209.24-1209.116z"
        fillRule="evenodd"
      />
    </svg>
  );
};
